import React, { useState, useEffect, Suspense } from 'react';
import PropTypes from 'prop-types';

/**
 * PersistentChatLayout component
 *
 * This component wraps the entire application and ensures that the ChatWindow
 * and TutorialWidget components remain mounted across page navigations.
 * Optimized to delay loading of heavy widgets until after LCP.
 */
const PersistentChatLayout = ({ children }) => {
  const [showWidgets, setShowWidgets] = useState(false);
  const [ChatWidget, setChatWidget] = useState(null);
  const [TutorialWidget, setTutorialWidget] = useState(null);

  useEffect(() => {
    const loadWidgets = async () => {
      const [chatModule, tutorialModule] = await Promise.all([
        import('./ChatWindow'),
        import('./TutorialWidget')
      ]);

      setChatWidget(() => chatModule.default);
      setTutorialWidget(() => tutorialModule.default);
      setShowWidgets(true);
    };

    const timeoutId = setTimeout(() => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(loadWidgets);
      } else {
        loadWidgets();
      }
    }, 4000);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      {children}
      {showWidgets && ChatWidget && TutorialWidget && (
        <Suspense fallback={null}>
          <TutorialWidget />
          <ChatWidget />
        </Suspense>
      )}
    </>
  );
};

PersistentChatLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PersistentChatLayout;
